class TypeColor {
  constructor() {
    this.init();
  }

  events() {
    document.addEventListener(
      "switch.change",
      (event) => {
        event.detail.switch.closest(".input-group").querySelector('input[type="color"]').disabled =
          !event.detail.switch.checked;
      },
      false
    );
  }

  init() {
    this.events();
  }
}

export { TypeColor };
